import { render } from "./DatePick.vue?vue&type=template&id=36fb3f6c"
import script from "./DatePick.vue?vue&type=script&lang=js"
export * from "./DatePick.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__